export default "__VITE_ASSET__BfVR7uSn__"